(function () {

  function forceStickyReset() {

    var info = document.querySelector('.Product__Info');

    if (!info) return;

    info.style.top = "0px";

    requestAnimationFrame(function () {

      window.dispatchEvent(new Event("scroll"));

      requestAnimationFrame(function () {

        window.dispatchEvent(new Event("scroll"));

      });

    });

  }

  document.addEventListener("click", function (e) {

    var btn = e.target.closest("[data-action='toggle-collapsible']");

    if (!btn) return;

    setTimeout(forceStickyReset, 400);

  });

})();